import { useContext, useEffect, useRef, useState } from "react";
import { GetRecents } from "../../Helper/RecentCart";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { ConfigContext } from "../../Context/ConfigContext";
import Carousel from 'react-multi-carousel';
import axios from "axios";
import { AddToCartNotifier } from "../../Components/CartComponents";
import { CartsContext } from "../../Context/CartsContext";
import { toast } from "react-toastify";
import { axiosGet } from "../../Apis/axiosMethods";
import { default_image } from "../../Imgaes";

const RecentViews = () => {
  const [recents, setRecents] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const locale = localStorage.getItem('lang');
  const dir = localStorage.getItem('dir');
  const { gdcURL, apiURL, currency, apiB2BURL, apiHeaderJson, business_type, setIsCartDropdownOpen } = useContext(ConfigContext);
  const [loading, setLoading] = useState(true);

  const [responsive] = useState({
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
      slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 2 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 1
    }
  })

  useEffect(() => {
    LoadRecents();
  }, [])

  const LoadRecents = async () => {

    try {

      setLoading(true);

      // ✅ local recents
      let recentItems = localStorage.getItem('recents')
        ? JSON.parse(localStorage.getItem('recents'))
        : [];

      // ✅ remove duplicates before API call
      const uniqueLocalRecents = recentItems.filter(
        (item, index, self) => {

          return index === self.findIndex((t) => {

            // ✅ OE PARTS
            if (
              Number(item.stock_oe) === 1 ||
              Number(item.stock_oe) === 2
            ) {

              return (
                t.item_number
                  ?.replace(/[-\s]/g, '')
                  ?.trim()
                  ?.toLowerCase() ===
                item.item_number
                  ?.replace(/[-\s]/g, '')
                  ?.trim()
                  ?.toLowerCase()
                &&
                t.item_brand_name
                  ?.trim()
                  ?.toLowerCase() ===
                item.item_brand_name
                  ?.trim()
                  ?.toLowerCase()
              );
            }

            // ✅ REGULAR STOCK
            return (
              t.item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase() ===
              item.item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase()
              &&
              Number(t.item_sup_id) ===
              Number(item.item_sup_id)
            );
          });
        }
      );

      // ✅ update localstorage
      localStorage.setItem(
        'recents',
        JSON.stringify(uniqueLocalRecents)
      );

      const formData = {
        currency: currency,
        lang: locale,
        recents: JSON.stringify(uniqueLocalRecents),
        type: business_type
      };

      const response = await axiosGet(`/Orders/GetRecentViews`, formData);

      // ✅ remove duplicates from API response also
      const uniqueApiRecents = (response?.data?.data || []).filter(
        (item, index, self) => {

          return index === self.findIndex((t) => {

            // ✅ OE PARTS
            if (
              Number(item.stock_oe) === 1 ||
              Number(item.stock_oe) === 2
            ) {

              return (
                t.item_number
                  ?.replace(/[-\s]/g, '')
                  ?.trim()
                  ?.toLowerCase() ===
                item.item_number
                  ?.replace(/[-\s]/g, '')
                  ?.trim()
                  ?.toLowerCase()
                &&
                t.item_brand_name
                  ?.trim()
                  ?.toLowerCase() ===
                item.item_brand_name
                  ?.trim()
                  ?.toLowerCase()
              );
            }

            // ✅ REGULAR STOCK
            return (
              t.item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase() ===
              item.item_number
                ?.replace(/[-\s]/g, '')
                ?.trim()
                ?.toLowerCase()
              &&
              Number(t.item_sup_id) ===
              Number(item.item_sup_id)
            );
          });
        }
      );

      setRecents(uniqueApiRecents);

    } catch (error) {

      console.log("recentviewerror", error);

    } finally {

      setLoading(false);
    }
  };

  const { AddToCart, GetCartItemQty } = useContext(CartsContext);
  const isAddingRef = useRef(false);
  const [addToCartLoading, setAddToCartLoading] = useState(false);



  const handleAddToCart = async (part) => {
    if (isAddingRef.current) return;
    isAddingRef.current = true;
    try {
      setAddToCartLoading(true);
      var prev_qty = await GetCartItemQty(part?.item_number);

      if (!part?.item_max_qty || part?.item_max_qty === 0) {
        toast.success(
          <AddToCartNotifier
            item_name={'We dont have stock for this part'}
            item_img={''}
          />,
          {}
        );
      }
      else if (part?.item_max_qty >= prev_qty + 1) {

        const partImg = part?.item_img_url
          ? `${gdcURL}/images/${part?.item_img_url}`
          : `${apiURL}/public/placeholder_category.jpeg`;


        const item = {
          ART_ID: part?.item_id,
          ART_ARTICLE_NR: part?.item_number,
          PRODUCT_GROUP_EN: part?.item_title,
          stock_price_mrp: part?.item_mrp,
          VD_BB_PRICE: part?.VD_BB_PRICE,
          VD_BG_PRICE: part?.VD_BG_PRICE,
          ART_SUP_ID: part?.item_sup_id || 0,
          ART_SUP_BRAND: part?.item_brand_name,
          inventory_store_id: part?.inventory_store_id,
          stock_oe: part?.stock_oe ?? 0,
          VD_QTY: part?.item_max_qty,
          stock_delivery_days: part?.stock_delivery_days
        }

        await AddToCart(item, 1, partImg, part?.item_url);

        setIsCartDropdownOpen(true);
        window.scrollTo(0, 0);

      }
      else {
        toast.success(
          <AddToCartNotifier
            item_name={'We dont have enough stock for this part'}
            item_img={''}
          />,
          {}
        );
      }
    } catch (error) {

    } finally {
      setAddToCartLoading(false);
      isAddingRef.current = false;
    }
  };


  return (
    recents && recents.length > 0 ? <section className="featured-products-section bg-white" >
      <div className="container" dir={dir} style={{ textAlign: dir === 'rtl' ? 'right' : 'left' }}>
        <h2 className="product-title">{t('recent_views')}</h2>
        <div >
          <Carousel
            swipeable={true}
            draggable={false}
            showDots={false}
            responsive={responsive}
            infinite={false}
            autoPlaySpeed={1000}
            keyBoardControl={true}
            customTransition="all .5"
            transitionDuration={500}
            containerClass="carousel-container"
            removeArrowOnDeviceType={["tablet", "mobile"]}
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            rtl={dir === 'rtl'}>
            {
              recents.map((recent, index) => {

                const partImg =
                  (Number(recent?.stock_oe) === 1 || Number(recent?.stock_oe) === 2) ?
                    recent?.item_img_url :
                    recent.item_img_url ?
                      `${recent.item_img_url}`
                      : default_image

                return <div key={`views-key-${index}`} style={{ backgroundColor: 'unset' }} >
                  <div key={`recent-${index}`} className="col-md-12">
                    <div className="card pl-3 pr-3 pt-3" style={{ border: '1px solid #efefef' }}>
                      <NavLink to={recent.item_url}>
                        <img
                          onClick={() => {
                            navigate(recent.url);
                            window.scrollTo(0, 0)
                          }}
                          style={{
                            height: '120px',
                            display: 'block',
                            margin: '0 auto'
                          }}
                          src={partImg || default_image}
                          alt={recent.item_title}
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = default_image;
                          }}
                        />
                      </NavLink>
                      <div className=" pt-5" style={{ minHeight: '130px' }}>
                        {/* <div className="d-flex align-items-center">
                        <div className="star-rating " style={{ color: 'orange' }}>
                          ★★★★☆
                        </div>
                        <small className="ml-2 nav-link-custom-under">(4.5)</small>
                      </div> */}
                        <NavLink className={`nav-link-custom-under`} to={recent.item_url}>
                          <h5 style={{
                            margin: 0,
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}>{recent.item_title}</h5>
                          <small>{t('article_number', { value: recent.item_number })}</small>
                        </NavLink>
                      </div>


                      {
                        (
                          recent?.item_max_qty > 0 &&
                          (
                            (
                              Number(business_type) === 1 ||
                              Number(business_type) === 2
                            )
                              ? (
                                Number(recent?.VD_BG_PRICE) > 0
                                  ? recent?.VD_BG_PRICE
                                  : recent?.VD_BB_PRICE
                              )
                              : recent?.VD_BB_PRICE
                          ) > 0
                        ) ? (

                          <>
                            <div
                              className="pb-2"
                              style={{ color: '#999' }}
                            >

                              <h3 style={{ lineHeight: 0 }}>
                                {recent?.display_price}
                              </h3>

                              {/* <small>
                                {t('price_included_vat_excluded_delivery')}
                              </small> */}
                              <small>
                                Offer price excl. 5.0% VAT, Free delivery
                              </small>

                            </div>

                            <button
                              onClick={() => {
                                handleAddToCart(recent)
                              }}
                              disabled={
                                addToCartLoading ||
                                isAddingRef.current
                              }
                              className="btn btn-dark add-cart mr-2 text-light mb-1"
                            >
                              {/* <i className="icon-shopping-cart mr-2" /> */}
                              <i className="fas fa-shopping-cart mr-2"></i>

                              <span>{t('add_to_cart')}</span>
                            </button>
                          </>

                        ) : (

                          <>
                            <div
                              className="pb-2"
                              style={{ color: '#999' }}
                            >

                              <NavLink to={recent?.item_url}>

                                <h3
                                  style={{
                                    lineHeight: 0,
                                    textAlign: 'center'
                                  }}
                                >
                                  {t('out_of_stock')}
                                </h3>

                              </NavLink>

                            </div>

                            <NavLink
                              to={recent?.item_url}
                              onClick={() => {
                                window.scrollTo(0, 0)
                              }}
                              className="btn btn-sm btn-dark add-cart mr-2 text-light mb-1"
                            >
                              <i className="icon-shopping-cart" />

                              <span>{t('details')}</span>
                            </NavLink>
                          </>
                        )
                      }




                    </div>
                  </div></div>
              })
            }
          </Carousel>
        </div>

      </div></section>
      : <div></div>


  )
}
export default RecentViews;